let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("qhUmM")).then(() => parcelRequire('hx4EP'));